import { useEffect, useState } from "react";
import { STICKY } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      data-testid={STICKY.mobile}
      className={`md:hidden fixed left-3 right-3 bottom-3 z-40 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="rounded-2xl bg-[var(--aura-charcoal)] text-[var(--aura-ivory)] shadow-2xl p-3 flex items-center gap-2">
        <button
          onClick={() => scrollTo("events")}
          className="flex-1 font-ui text-sm px-4 py-2.5 rounded-xl bg-[var(--aura-teal)] hover:bg-[var(--aura-teal-hover)] inline-flex items-center justify-center gap-1.5"
        >
          Explore Events <ArrowRight size={14} />
        </button>
        <button
          onClick={() => scrollTo("enquiry")}
          className="flex-1 font-ui text-sm px-4 py-2.5 rounded-xl border border-white/20 hover:bg-white/10"
        >
          Enquire
        </button>
      </div>
    </div>
  );
}
